import { ShipmentStatus } from '@shared-features/enums/shipment-status.enum';
import { B2cShipmentStatus } from '../enums/b2c-shipment-status.enum';

export const isAllowToCancelShipment = (shipmentStatus: B2cShipmentStatus) => {
  return ![
    B2cShipmentStatus.Lost,
    B2cShipmentStatus.Damaged,
    B2cShipmentStatus.Delivered,
    B2cShipmentStatus.PickedByConsumer,
    B2cShipmentStatus.Canceled,
  ].includes(shipmentStatus);
};

export const isAllowToCancelIntegration = (shipmentStatus: B2cShipmentStatus) => {
  return ![
    B2cShipmentStatus.Lost,
    B2cShipmentStatus.Damaged,
    B2cShipmentStatus.Delivered,
    B2cShipmentStatus.PickedByConsumer,
    B2cShipmentStatus.OrderPickedUp,
    B2cShipmentStatus.OutForDelivery,
    B2cShipmentStatus.ReturnToOrigin,
    B2cShipmentStatus.Canceled,
    B2cShipmentStatus.ShipmentIntegrationCanceled,
    B2cShipmentStatus.NotPickedUp,
    B2cShipmentStatus.Created,
  ].includes(shipmentStatus);
};

export const isAllowToAssignFleetShipment = (shipmentStatus: B2cShipmentStatus) => {
  return [
    B2cShipmentStatus.Created,
    B2cShipmentStatus.ReturnToOrigin,
    B2cShipmentStatus.ShipmentIntegrationCanceled,
    B2cShipmentStatus.NotPickedUp,
    B2cShipmentStatus.Canceled,
  ].includes(shipmentStatus);
};

export const isAllowToSyncFleetShipment = (shipmentStatus: B2cShipmentStatus) => {
  return ![
    B2cShipmentStatus.Created,
    B2cShipmentStatus.Canceled,
    B2cShipmentStatus.Delivered,
    B2cShipmentStatus.PickedByConsumer,
    B2cShipmentStatus.ShipmentIntegrationCanceled,
    B2cShipmentStatus.NotPickedUp,
    B2cShipmentStatus.Lost,
    B2cShipmentStatus.Damaged,
  ].includes(shipmentStatus);
};

export const isAllowToDownloadAWB = (shipmentStatus: B2cShipmentStatus) => {
  return ![
    B2cShipmentStatus.Created,
    B2cShipmentStatus.ShipmentIntegrationCanceled,
    B2cShipmentStatus.NotPickedUp,
  ].includes(shipmentStatus);
};

export const isAllowToPickByConsumer = (shipmentStatus: B2cShipmentStatus) => {
  return [
    B2cShipmentStatus.Created,
    B2cShipmentStatus.Canceled,
    B2cShipmentStatus.ReturnToOrigin,
    B2cShipmentStatus.ShipmentIntegrationCanceled,
    B2cShipmentStatus.NotPickedUp,
  ].includes(shipmentStatus);
};

export const isAllowToEditShipment = (shipmentStatus: B2cShipmentStatus) => {
  return [
    B2cShipmentStatus.Created,
    B2cShipmentStatus.Canceled,
    B2cShipmentStatus.Delivered,
    B2cShipmentStatus.ReturnToOrigin,
    B2cShipmentStatus.ShipmentIntegrationCanceled,
    B2cShipmentStatus.NotPickedUp,
  ].includes(shipmentStatus);
};

export const isAllowToEditZone = (shipmentStatus: B2cShipmentStatus) => {
  return [
    B2cShipmentStatus.Created,
    B2cShipmentStatus.Canceled,
    B2cShipmentStatus.Delivered,
    B2cShipmentStatus.ReturnToOrigin,
    B2cShipmentStatus.ShipmentIntegrationCanceled,
    B2cShipmentStatus.NotPickedUp,
  ].includes(shipmentStatus);
};

export const isAllowToAssignProvider = (shipmentStatus: ShipmentStatus) => {
  return [ShipmentStatus.New, ShipmentStatus.Accepted].includes(shipmentStatus);
};
